// extracted by mini-css-extract-plugin
export default {"colCont":"ColumnView_colCont__TIKa7"};